export class DefinedMetaElementInfoPropertyDef {
  public static readonly CUSTOM_IMAGE_HASH: string = 'customImageHash';
  public static readonly CONNECTION_CORRIDOR: string = 'connectionCorridor';

  public static readonly BACKWARD_REFERENCE_ARTICLE_USAGE_ID: string = 'backwardReferenceArticleUsageId';
  public static readonly SPACING: string = 'spacing';
}
